module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-192x192-6c28f8d4a5b7a8d59c8b8d4744c43266.png";